import React, { useState, useEffect } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import { FileUploader } from "../../../../components/ImageUploader";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const EditBirthdayCard = ({ fetchAppraisal, EmployeeListdata, editId }) => {
  const { emp_id, emp_name } = useParams();
  const [selected_emp, setSelectedEmp] = useState({});
  const [profilePic, setProfilePic] = useState("");
  
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState([]);
  const [formData, setFormData] = useState({
    selectedOption: null,

    checkedItems: [],
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [value, setValue] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetchEditData();
  }, []);
  const fetchEditData = async () => {
    
    try {
      const response = await GetServiceCaller(
        `${API_URL}birthday-card/${emp_id}`
      );
    
      if (response?.data?.status === "failed") {
        navigate('/', { replace: true });
        return;
      }
    
      // Process successful response
      const data = response.data.birthdaydetails;
      setValue({ value: data.emp_id, label: data.name });
    
      if (data.hasFile) {
        setProfilePic(data.file);
      }
    } catch (error) {
        navigate('/', { replace: true });
    }
  };

  const handleFile = (file) => {
    const fileType = file.type;
    const fileSize = file.size;
    if (fileType !== "image/png" && fileType !== "image/jpeg") {
      setErrorMessage("Only PNG and JPEG formats are allowed.");
      return;
    }
    if (fileSize > 300 * 1024) {
      // 300 KB
      setErrorMessage("File size should be less than 300 KB.");
      return;
    }
    setErrorMessage("");
    setFileName(file.fileName);
    setFile(file);
    const previewUrl = URL.createObjectURL(file);
    setProfilePic(previewUrl);
    setFormData((prevState) => ({
      ...prevState,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("EmployeeID", value.value);
    data.append("BirthdayImage", file);
    data.append("fileName", file.name);

    try {
      let response = await PostFormServiceCaller(
        `${API_URL}birthday-card-store`,
        data,
        "post"
      );
      toast.success("Data submitted successfully!");
    } catch (error) {
      toast.error("Error submitting data.");
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Birthday Details"));
  }, []);

  return (
    <>
      <div className="container-fluid" id="skill_section">
          <div className="row mt-5">
            <div className="col-sm-6 offset-sm-3">
              <div className="card">
                <Card.Body>
                  <Form>
                    <div className="row">
                      <div className="col-12 col-lg-6 text-center">
                        <div className="profile-pic-container mb-3">
                          <p className="text-muted">
                            *Upload photo size should be less than 300KB
                          </p>
                          <img
                            id="profilePic"
                            className="profile-pic  mb-2"
                            src={
                              profilePic || "https://via.placeholder.com/150"
                            }
                            alt="Birthday Pic"
                          />
                        <div className="col-sm-12">
                            <div className="mt-2">
                              <FileUploader handleFile={handleFile} />
                              {fileName ? (
                                <p className="mt-2 text-success">
                                  Uploaded: {fileName}
                                </p>
                              ) : null}
                              {errorMessage && (
                                <Alert variant="danger">{errorMessage}</Alert>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="row mb-2">
                          <div className="col-sm-12">
                            <Form.Group>
                              <Form.Label style={{ fontSize: "0.875rem" }}>
                                Employee Name
                              </Form.Label>
                              <Select
                                isDisabled={true}
                                className="basic-single"
                                classNamePrefix="select"
                                onChange={setValue}
                                value={value}
                                options={[value, ...[]]}
                                placeholder="Select Employee"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    fontSize: "0.875rem", // Adjust the font size for the select input
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    fontSize: "0.875rem", // Adjust the font size for the selected value
                                  }),
                                }}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-2 mt-3">
                          <div className="d-flex justify-content-end">
                            <button type="submit" className="me-2 cancel-btn"  onClick={()=> navigate("/dashboard")}>
                              Cancel
                            </button>
                            <button
                              onClick={(e) => handleSubmit(e)}
                              type="submit"
                              className="custom-btn"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                    </div>
                  </Form>
                </Card.Body>
              </div>
            </div>
          </div>

      </div>
    </>
  );
};

export default EditBirthdayCard;
